<div style="width: 1000px" [ngClass]="isSourceSiteUser && showActionButtons ? 'esvr--editable' : 'esvr--notEditable'">
  <form [formGroup]="form" *ngIf="portalState">
    <div class="modal-close">
      <button type="button" (click)="closeSidenav()" class="clost-btn">
        <img src="assets/svg/icons/modal-close.svg" />
      </button>
    </div>

    <div class="dispatchAction">
      <h1 class="modalHeader">ESVR Details</h1>
      <div *ngxPermissionsExcept="[UserRole.QualifiedPerson, UserRole.QualifiedPersonSiteUser]">
        <div
          [ngClass]="{
            dispatchButtons: isSourceSiteUser,
            fillSiteActions: isFillSiteUser
          }"
          *ngIf="(isSourceSiteUser || isFillSiteUser) && accessToActions"
        >
          <div
            [ngClass]="{
              actionContainer: isFillSiteUser
            }"
          >
            <button
              mat-raised-button
              class="editWithIconBtn"
              [class.dispatchESVR]="isSourceSiteUser && !showActionButtons"
              (click)="editESVR()"
              *ngIf="!editing && !isArchived">
              <mat-icon svgIcon="edit-icon"></mat-icon> Edit
            </button>
            <button
              mat-raised-button
              class="cmn-green-btn"
              *ngIf="editing && isFillSiteUser && isRejected"
              (click)="isValid(ActionType.Accept)"
            >
              Approve
            </button>
            <button
              mat-raised-button
              class="cmn-danger-btn"
              *ngIf="editing && isFillSiteUser && isReceived"
              #triggerDispute="matMenuTrigger"
              [matMenuTriggerFor]="dispute"
            >
              Reject
            </button>
            <button mat-raised-button [class.dispatchESVR]="isSourceSiteUser && !showActionButtons" (click)="saveChanges()" *ngIf="editing">
              Save
            </button>
            <button
              *ngIf="isSourceSiteUser && showActionButtons"
              (click)="isValid(ActionType.Dispatch)"
              mat-raised-button
              class="cmn-green-btn dispatchButton dispatchESVR"
            >
              {{ 'Dispatch.DispatchESVR' | translate }}
            </button>
            <button
              *ngIf="isFillSiteUser && showActionButtons"
              (click)="isValid(ActionType.Accept)"
              mat-raised-button
              class="cmn-green-btn dispatchButton"
            >
              Accept
            </button>
            <button
              *ngIf="isFillSiteUser && showActionButtons"
              #triggerDispute="matMenuTrigger"
              mat-raised-button
              [matMenuTriggerFor]="dispute"
              class="cmn-danger-btn dispatchButton"
            >
              {{ 'Common.Dispute' | translate }}
            </button>
          </div>
          <div #triggerAccept="matMenuTrigger" [matMenuTriggerFor]="accept">
            <mat-menu overlapTrigger="false" #accept class="esvrOverlay">
              <app-esvr-accept (click)="$event.stopPropagation()" (closeMenu)="acceptESVR($event)" (keydown.tab)="$event.stopPropagation()">
              </app-esvr-accept>
            </mat-menu>
          </div>
          <mat-menu overlapTrigger="false" #dispute class="esvrOverlay">
            <app-esvr-dispute
              (click)="$event.stopPropagation()"
              (closeMenu)="CloseDisputeESVR()"
              (rejectESVR)="rejectESVR($event)"
              (holdESVR)="holdESVR($event)"
              [status]="(esvr$ | async)?.status"
              (keydown.tab)="$event.stopPropagation()"
            >
            </app-esvr-dispute>
          </mat-menu>
          <div #triggerDispatch="matMenuTrigger" [matMenuTriggerFor]="dispatch">
            <mat-menu overlapTrigger="false" #dispatch class="esvrOverlay">
              <app-esvr-dispatch
                (click)="$event.stopPropagation()"
                (closeMenu)="dispatchESVR($event)"
                (keydown.tab)="$event.stopPropagation()"
              >
              </app-esvr-dispatch>
            </mat-menu>
          </div>
        </div>
      </div>
    </div>
    <mat-divider></mat-divider>

    <app-esvr-load-information [loadInfo]="loadInfo"></app-esvr-load-information>
    <mat-divider></mat-divider>

    <app-esvr-transport-information
      #transport
      formGroupName="esvrTransportInformationForm"
      [portalState]="portalState"
      [submited]="submited"
      [editing]="editing"
    >
    </app-esvr-transport-information>
    <mat-divider></mat-divider>

    <app-esvr-date-time-information formGroupName="esvrDateTimeInformationForm" [editing]="editing"></app-esvr-date-time-information>
    <mat-divider></mat-divider>

    <app-esvr-weight-placement-location
      formGroupName="esvrWeighPlacementLocationForm"
      [portalState]="portalState"
      [submited]="submited"
      [editing]="editing"
    >
    </app-esvr-weight-placement-location>
    <mat-divider></mat-divider>

    <app-esvr-site-contacts
      formGroupName="esvrSiteContactsForm"
      [contactInfo]="contactInfo"
      [portalState]="portalState"
      [editing]="editing"
      [isSourceSiteUser]="isSourceSiteUser"
      [isFillSiteUser]="isFillSiteUser"
    >
    </app-esvr-site-contacts>
    <mat-divider></mat-divider>

    <app-esvr-audit-trails [auditTrails]="(esvr$ | async)?.auditTrails"></app-esvr-audit-trails>

    <div *ngxPermissionsExcept="[UserRole.QualifiedPerson, UserRole.QualifiedPersonSiteUser]" class="dispatchAction">
      <div
        [ngClass]="{
          fillSiteActions: isFillSiteUser
        }"
        *ngIf="(isSourceSiteUser || isFillSiteUser) && accessToActions"
      >
        <div
          [ngClass]="{
            actionContainer: isFillSiteUser
          }"
        >
          <button mat-raised-button [class.dispatchESVR]="isSourceSiteUser && !showActionButtons" (click)="saveChanges()" *ngIf="editing">
            Save
          </button>
          <button
            *ngIf="isSourceSiteUser && showActionButtons"
            (click)="isValid(ActionType.Dispatch)"
            mat-raised-button
            class="cmn-green-btn dispatchButton dispatchESVR"
          >
            {{ 'Dispatch.DispatchESVR' | translate }}
          </button>

          <button
            *ngIf="isFillSiteUser && showActionButtons"
            (click)="isValid(ActionType.Accept)"
            mat-raised-button
            class="cmn-green-btn dispatchButton"
          >
            Accept
          </button>
          <button
            *ngIf="isFillSiteUser && showActionButtons"
            (click)="openDisputeMenu()"
            mat-raised-button
            class="cmn-danger-btn dispatchButton"
          >
            {{ 'Common.Dispute' | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
